export const SET_TRANSFER = 'TRANSFER/SET';
export const CLEAR_TRANSFER = 'TRANSFER/CLEAR';
export const SET_USER = 'USER/SET';
export const SET_BALANCE = 'BALANCE/SET';
export const SET_ERROR = 'ERROR/SET';
export const CLEAR_ERROR = 'ERROR/CLEAR';
export const SET_COUNTRY = 'COUNTRY/SET';
export const CLEAR_COUNTRY = 'COUNTRY/CLEAR';
export const SET_REGIONS = 'REGIONS/SET';
export const CLEAR_REGIONS = 'REGIONS/CLEAR';
export const SET_REGIONS_TYPES = 'REGIONS/TYPES//SET';
export const CLEAR_REGIONS_TYPES = 'REGIONS/TYPES/CLEAR';
export const SET_IS_CONFIRM_RECEIVER_DETAIL = 'IS_CONFIRM_RECEIVER_DETAIL/SET';
export const SET_RECEIVER_NATIONAL_ID = 'RECEIVER_NATIONAL_ID/SET';
export const CLEAR_RECEIVER_NATIONAL_ID = 'RECEIVER_NATIONAL_ID/CLEAR';
